import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/[lang]/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/client/ActionBlock/FormatActionBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/client/LayoutComponent/LayoutComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/client/PromotionBanner/PromotionBannerConnector.js");
